import React from "react";
import { FiFilter, FiGrid, FiList } from "react-icons/fi";

const CollectionToolbar = ({ count, sort, onSort, view, onView, onFilter }) => (
  <div className="collection-toolbar">
    <button className="collection-toolbar__filter" type="button" onClick={onFilter}>
      <FiFilter aria-hidden="true" /> Filters
    </button>
    <p>{count} {count === 1 ? "product" : "products"}</p>
    <div className="collection-toolbar__controls">
      <label>
        <span>Sort by</span>
        <select value={sort} onChange={(event) => onSort(event.target.value)}>
          <option value="featured">Featured</option>
          <option value="best-selling">Best selling</option>
          <option value="rating">Top rated</option>
          <option value="price-asc">Price, low to high</option>
          <option value="price-desc">Price, high to low</option>
          <option value="name-asc">Alphabetically, A–Z</option>
        </select>
      </label>
      <div className="collection-toolbar__view" aria-label="Product view">
        <button type="button" className={view === "grid" ? "is-active" : ""} onClick={() => onView("grid")} aria-label="Grid view" aria-pressed={view === "grid"}><FiGrid /></button>
        <button type="button" className={view === "list" ? "is-active" : ""} onClick={() => onView("list")} aria-label="List view" aria-pressed={view === "list"}><FiList /></button>
      </div>
    </div>
  </div>
);

export default CollectionToolbar;
